import React from 'react';
import { X } from 'lucide-react';
import type { LeaseholderFilter } from '../../types/leaseholder';

interface ActiveLeaseholderFiltersProps {
  filters: LeaseholderFilter;
  onRemoveFilter: (key: keyof LeaseholderFilter) => void;
}

export default function ActiveLeaseholderFilters({ filters, onRemoveFilter }: ActiveLeaseholderFiltersProps) {
  const hasActiveFilters = Object.values(filters).some(Boolean);
  
  if (!hasActiveFilters) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {filters.position && (
        <FilterTag
          label="Position"
          value={filters.position}
          onRemove={() => onRemoveFilter('position')}
        />
      )}
      {filters.state && (
        <FilterTag
          label="State"
          value={filters.state}
          onRemove={() => onRemoveFilter('state')}
        />
      )}
      {filters.hasABN !== null && (
        <FilterTag
          label="ABN Status"
          value={filters.hasABN ? 'Has ABN' : 'No ABN'}
          onRemove={() => onRemoveFilter('hasABN')}
        />
      )}
    </div>
  );
}

interface FilterTagProps {
  label: string;
  value: string;
  onRemove: () => void;
}

function FilterTag({ label, value, onRemove }: FilterTagProps) {
  return (
    <div className="flex items-center gap-1 text-sm bg-gray-100 text-gray-700 px-2 py-1 rounded-md">
      <span className="font-medium">{label}:</span>
      <span>{value}</span>
      <button
        onClick={onRemove}
        className="ml-1 p-0.5 hover:bg-gray-200 rounded-full"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
